const mutations = {
    TOGGLE_SELECTED(state, value) {
        let index = state.selected.indexOf(value);
        if (index > -1) state.selected.splice(index, 1);
        else state.selected.push(value);
    },

    CLEAR_SELECTED(state, filter) {
        state.selected = [];
    },

    TOGGLE_ALL_ROW_SELECTED(state, payload) {
        payload.ids.forEach(function(id) {
            if (payload.insert) {
                if (state.selected.indexOf(id) < 0) state.selected.push(id);
            } else {
                let index = state.selected.indexOf(id);
                if (index > -1) state.selected.splice(index, 1);
            }
        });
    },
};

export default mutations;



// WEBPACK FOOTER //
// ./resources/assets/js/components/vuetable2/checkbox/state/mutation.js